import { AxiosAdapter } from '../commons/adapters';
import { QueryPagination } from '../commons/interfaces';
import { buildQuery } from '../commons/utils/helpers';

const http = new AxiosAdapter();
const BASE_URL = '/v1/services-ia-global-config';

export const getAllServicesIaGlobalConfigService = async (query?: QueryPagination) => {
  try {
    return await http.get<any>(`${BASE_URL}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAllServicesIaGlobalConfigService error', error);
  }
};

export const getServicesIaGlobalConfigByIdService = async (id: string) => {
  try {
    return await http.get<any>(`${BASE_URL}/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaGlobalConfigByIdService error', error);
  }
};

export const createServicesIaGlobalConfigService = async (data: any) => {
  try {
    return await http.post<any>(BASE_URL, data, null);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('createServicesIaGlobalConfigService error', error);
  }
};

export const updateServicesIaGlobalConfigService = async (id: string, data: any) => {
  try {
    return await http.put<any>(`${BASE_URL}/${id}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('updateServicesIaGlobalConfigService error', error);
  }
};

export const deleteServicesIaGlobalConfigService = async (id: string, query?: QueryPagination) => {
  try {
    return await http.deleteTable<any>(`${BASE_URL}/${id}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('deleteServicesIaGlobalConfigService error', error);
  }
};

export const restoreServicesIaGlobalConfigService = async (id: string, query?: QueryPagination) => {
  try {
    return await http.patchTable<any>(`${BASE_URL}/${id}/restore?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('restoreServicesIaGlobalConfigService error', error);
  }
};

export const getAppsToDropdownService = async () => {
  try {
    return await http.get<any>(`${BASE_URL}/form`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAppsToDropdownService error', error);
  }
};
